<script>
	// Stores 
	import { textSite } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader from "../components/PageHeader.svelte";

   	// Code	
	let titlePage = 'Administração de Condomínios ';	
</script>

<PageHeader title={titlePage}></PageHeader>
<div class="container clearfix text-justify">
	<p>Administração de condomínios com agilidade e competência.</p>
	<p>Conte com nossa equipe especializada e modernas ferramentas para garantir uma gestão tranquila do seu condomínio.</p>

	<hr>
	<div class="button mt-40 text-center">        
		<a href="/solicite-proposta" use:link replace title="" class="btn btn-secondary">
			Solicite uma proposta <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> 
		</a>
	</div>        

</div>

<style type="text/sass">

.card-border
	padding: 20px
	display: flex
	align-items: center
	flex-direction: column
	h2
		font-size: 16px
	p 
		font-size: 12px
		line-height: 120%

</style>
